import { Spinner } from "@syncfusion/ej2-react-pdfviewer";
import React from "react";
import { Modal, ModalHeader } from "reactstrap";

export const ModalLayoutMWCD = (props) => {
  const {
    isOpen,
    message = "",
    onCancel,
    onConfirm,
    confirmButtonLabel = "Submit",
    icon = "",
    iconClass = "",
    modalFooter = null,
    modalMainFooter = null,
    modalBody = null,
    modalButtonGroup = null,
    modalStyle = { maxWidth: "400px" },
    header = "",
    HeaderComponent = null,
    isLoading = false,
    customClass = "",
    commonModalStyle = "",
  } = props;

  return (
    <Modal
      isOpen={isOpen}
      toggle={onCancel}
      centered
      scrollable
      className={`common-modal ${customClass}`}
      style={modalStyle}
    >
      {header && <ModalHeader>{header}</ModalHeader>}
      {HeaderComponent && HeaderComponent}
      <div className={`modal-body mwcd-modal-content ${commonModalStyle}`}>
        <div className="model-icon-body">
          {icon && (
            <img
              src={icon}
              alt=""
              className={iconClass ? iconClass : "modal-icon"}
            />
          )}
        </div>
        {message && <p className="py-2">{message}</p>}
        {modalBody && modalBody}
        <div className="modal-action-mwcd">
          {!modalButtonGroup && (
            <button
              type="button"
              onClick={onConfirm}
              className="btn btn-primary"
              disabled={isLoading}
            >
              {isLoading ? (
                <Spinner size="sm">Loading...</Spinner>
              ) : (
                confirmButtonLabel
              )}
            </button>
          )}
          {modalButtonGroup && modalButtonGroup}
        </div>

        {modalFooter && (
          <div className="modal-footer-content">{modalFooter}</div>
        )}
      </div>
      {modalMainFooter && (
        <div className="modal-footer-content">{modalMainFooter}</div>
      )}
    </Modal>
  );
};
